module.exports = __webpack_public_path__ + "static/media/photo-07.bbfad8b3.png";